<template>
<div>
  <h2>Tour bearbeiten</h2>

  <div class="ui form" style="text-align: left;">
    <div class="fields">
      <div class="field" style="width: 100%;">
        <label>Titel</label>
        <input type="text" v-model="data.titel" placeholder="Titel">
      </div>
    </div>
    <div class="fields">
      <div class="field" style="width: 100%;">
        <label>Kurzbeschreibung</label>
        <input type="text" v-model="data.short" placeholder="Kurzbeschreibzng">
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label>Startet am</label>
        <datetime v-model="data.startdate"></datetime>
      </div>
      <div class="field">
        <label>Endet am</label>
        <datetime v-model="data.enddate"></datetime>
      </div>
      <div class="field">
        <label>Land</label>
        <select v-model="data.country">
          <option disabled value="">Land</option>
          <option v-for="country in config.countries" v-bind:value="country.kv">{{country.de}}</option>
        </select>
      </div>
    </div>
    <!--

    -->
    <div class="three fields">
      <div class="field">
        <label>Startpunkt</label>
        <div class="ui icon input">
          <input v-model="data.location.starting.value" type="text" placeholder="PLZ Ort, Strasse" @input="onInput($event,'starting')">
          <i v-if="data.location.starting.valid" class="checkmark icon"></i>
        </div>
      </div>
      <div class="field">
        <label>Zielort</label>
        <div class="ui icon input">
          <input v-model="data.location.destination.value" type="text" placeholder="PLZ Ort, Strasse" @input="onInput($event,'destination')">
          <i v-if="data.location.destination.valid" class="checkmark icon"></i>
        </div>
      </div>
      <div class="field">
        <label>Wegpunkte</label>
        <button class="ui button" @click="addWaypoint()">+</button>
        <button class="ui button" @click="removeWaypoint()">-</button>
        <div v-for="(waypoint, index) in data.location.waypoints" style="margin-top: 5px;">

          <div class="ui icon input">
            <input v-model="waypoint.value" type="text" placeholder="PLZ Ort, Strasse" @input="onInput($event, index)">
            <i v-if="waypoint.valid" class="checkmark icon"></i>
          </div>
        </div>

      </div>

    </div>
    <label><b>Beschreibung</b></label>
    <quill-editor ref="description" v-model="data.description" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)">
    </quill-editor>
  </div>


  <br><br>

  <div class="ui grid">
    <div class="eight wide column">
      <div @click="setIndex($event,0)" v-bind:class="['big-tile',{ active: index==0 }]">
        <img v-bind:src="getImage(0)" width="300">
      </div>
    </div>
    <div class="eight wide column">
      <div class="ui grid">
        <div class="eight wide column">
          <div @click="setIndex($event,1)" v-bind:class="['small-tile',{ active: index==1 }]">
            <img v-bind:src="getImage(1)" width="150">
          </div>
        </div>
        <div class="eight wide column">
          <div @click="setIndex($event,2)" v-bind:class="['small-tile',{ active: index==2 }]">
            <img v-bind:src="getImage(2)" width="150">
          </div>
        </div>
        <div class="eight wide column">
          <div @click="setIndex($event,3)" v-bind:class="['small-tile',{ active: index==3 }]">
            <img v-bind:src="getImage(3)" width="150">
          </div>
        </div>
        <div class="eight wide column">
          <div @click="setIndex($event,4)" v-bind:class="['small-tile',{ active: index==4 }]">
            <img v-bind:src="getImage(4)" width="150">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="three fields" style="float: left;">
    <div class="field" style="float: left;">

      <image-uploader :debug="0" :maxWidth="500" :minWidth="500" :quality="0.7" :autoRotate=true outputFormat="verbose" :preview=false :className="['fileinput', { 'fileinput--loaded' : hasImage }]" capture="environment" accept="image/*" doNotResize="['gif', 'svg']"
        @input="setImage($event, index)"><label for="fileInput" slot="upload-label">
        <span class="upload-caption ui button">+ Bild hochladen</span>
      </label>
      </image-uploader>

    </div>
  </div>

  <div class="three fields" style="float: right; margin-top: 20px; margin-bottom: 30px;">
    <button @click="save()" v-bind:class="['ui', 'primary','button', transfer ? 'loading' : '']">
        Speichern
    </button>
    <button @click="abort()" class="ui button">
      Abbrechen
    </button>
    <button v-if="data.uid" @click="deleteTour()" class="ui red button">
      Löschen
    </button>
  </div>
</div>
</template>

<script>
import Config from '../Config';
const axios = require('axios');
import User from '../enteties/User';
import {
  quillEditor
} from 'vue-quill-editor';
import {
  Datetime
} from 'vue-datetime';


export default {
  name: 'TourPlanner',
  props: {},
  data: function() {
    return {
      config: Config,
      user: User,
      data: {
        images: [],
        preview: null,
        uid: null,
        location: {
          starting: {},
          destination: {},
          waypoints: []
        },
        data: {
          location: {},
          waypoints: []
        },
      },
      date: 0,
      index: 0,
      inputTimer: null,
      images: [],
      previews: [],
      hasImage: false,
      previewImage: null,
      transfer: false,
      geocoder: new google.maps.Geocoder(),
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['blockquote', 'code-block'],
            [{
              'header': 1
            }, {
              'header': 2
            }],
            ['link']
          ]
        }
      }
    }
  },
  created: function() {
    if (!this.user.logedin) {
      this.$router.push({
        path: 'login'
      })
    }

    if (this.$route.query.uid != null) {

      axios.get(this.config.protocol + "://" + this.config.apihost + "/private/tour/" + this.$route.query.uid)
        .then((response) => {
          this.data = response.data.data;
          this.data.startdate = new Date(this.data.startdate).toISOString();
          this.data.enddate = new Date(this.data.enddate).toISOString();
          this.data.uid = this.$route.query.uid;
        })
        .catch(function(error) {
          console.log(error);
        })
    }

  },
  components: {
    quillEditor,
    Datetime
  },
  methods: {
    save: function() {

      this.transfer = true;
      let sd = new Date(this.data.startdate);
      this.data.startdate = sd.getTime();

      let ed = new Date(this.data.enddate);
      this.data.enddate = ed.getTime();

      let data = {
        images: this.images,
        data: this.data
      };

      axios.post(this.config.protocol + "://" + this.config.apihost + "/private/tour", data)
        .then((response) => {
          this.transfer = false;
          this.$router.push({
            path: 'touren'
          })
        })
        .catch(function(error) {
          console.log(error);
          this.transfer = false;
        })

    },
    abort: function() {
      this.$router.push({
        path: 'touren'
      })
    },
    fileSelected: function(event, index) {

      let file = event.target.files[0];

      this.images.push(file);
      this.previews.push(URL.createObjectURL(file));
    },
    setImage: function(file, index) {
      //this.hasImage = true

      this.images[index] = file;

      this.setIndex(index);
    },
    delete: function() {


    },
    setIndex: function(event, index) {

      this.index = index;
    },
    getImage: function(index) {

      let img = "https://filedelivery.rewaco.com/files/touren/images/default.png";

      if (this.data.images[index] != undefined) {
        img = this.config.filedelivery + "/images/touren/" + this.data.images[index];
      }

      if (this.images[index] != undefined) {
        img = this.images[index] != null ? this.images[index].dataUrl : "https://filedelivery.rewaco.com/files/touren/images/default.png";
      }

      return img;
    },
    setPreviewImage: function(file) {
      //this.hasImage = true
      this.data.preview = file;
    },
    getLocation: function() {
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({
        'address': address
      }, function(results, status) {
        if (status === 'OK') {} else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    },
    addWaypoint: function() {
      this.data.location.waypoints.push({
        value: '',
        lat: '',
        lng: '',
        valid: false
      });
    },
    removeWaypoint: function() {
      this.data.location.waypoints.pop();
    },
    onInput: function(e, source) {

      var isWaypoint = !isNaN(parseFloat(source));

      clearTimeout(this.inputTimer);

      this.inputTimer = setTimeout(() => {

        console.log(isWaypoint);
        console.log(parseInt(source));
        console.log(this.data.location);
        let l = !isWaypoint ? this.data.location[source].value : this.data.location.waypoints[parseInt(source)].value;
        console.log(l);

        this.geocoder.geocode({
          'address': l
        }, (results, status) => {
          if (status === 'OK') {
            if (!isWaypoint) {
              this.data.location[source].lat = results[0].geometry.location.lat();
              this.data.location[source].lng = results[0].geometry.location.lng();
              this.data.location[source].valid = true;
            } else {
              this.data.location.waypoints[parseInt(source)].lat = results[0].geometry.location.lat();
              this.data.location.waypoints[parseInt(source)].lng = results[0].geometry.location.lng();
              this.data.location.waypoints[parseInt(source)].valid = true;
            }

          } else {
            alert('Geocode was not successful for the following reason: ' + status);
          }
        });
      }, 1000);


    }
  }
}
</script>

<style>
#fileInput {
  display: none;
}



.big-tile {
  border: 2px solid white;
  width: 304px;
  height: 304px;
}

.big-tile.active {
  border: 2px solid black;
  width: 304px;
  height: 304px;
}

.small-tile {
  border: 2px solid white;
  width: 154px;
  height: 154px;
}

.small-tile.active {
  border: 2px solid black;
  width: 154px;
  height: 154px;
}


.deactive {
  border: 1px solid black;
  max-width: 154px;
  max-height: 154px;
}

.notactive {
  border: 1px solid black;
  min-width: 150px;
  min-height: 150px;
}

.quill-editor {
  border: 1px solid #ccc;
  width: 100%;
}
</style>
